import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { classifyLoadError } from '@shared/lib/classify-load-error';
import { Button } from './button';
import { StatusBanner } from './status-banner';

export interface LoadErrorBannerProps {
  error: unknown;
  onRetry: () => void;
  retrying?: boolean;
  /** Ниже остаются прежние данные, их актуальность не подтверждена. */
  stale?: boolean;
}

export function LoadErrorBanner({ error, onRetry, retrying = false, stale = false }: LoadErrorBannerProps) {
  const { t } = useTranslation('cabinet');
  const kind = classifyLoadError(error);

  return (
    <StatusBanner variant="destructive" role="alert" data-error-kind={kind}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 space-y-1">
          <p className="font-medium">{t(`compliance.loadError.${kind}.title`)}</p>
          <p>{t(`compliance.loadError.${kind}.hint`)}</p>
          {stale ? <p className="text-xs">{t('compliance.loadError.stale')}</p> : null}
        </div>
        <div className="flex flex-col gap-2 sm:flex-row sm:shrink-0">
          {kind === 'totp' ? (
            <Button asChild size="sm" variant="outline" className="w-full sm:w-auto">
              <Link to="/security">{t('compliance.loadError.goSecurity')}</Link>
            </Button>
          ) : null}
          <Button type="button" size="sm" variant="outline" className="w-full sm:w-auto" disabled={retrying} onClick={onRetry}>
            {t('compliance.loadError.retry')}
          </Button>
        </div>
      </div>
    </StatusBanner>
  );
}
